import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import WidgetContainer from '../WidgetContainer'
import { useTranslation } from 'react-i18next'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import { useDispatch } from 'react-redux'
import LinkButton from 'srcReact/components/common2/LinkButton'

function GetToMeet({ title, participants, showUserModal, showMixrUrl, showProfileUrl }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [currentUser, setCurrentUser] = useState()
  const [currentUserIndex, setCurrentUserIndex] = useState()
  const [randomUsers, setRandomUsers] = useState([])

  useEffect(() => {
    setRandomUsers(participants)
    setCurrentUser(participants[0])
    setCurrentUserIndex(0)
  }, [participants])

  const handleShowUserModal = (user, userIndex) => {
    if (showUserModal) {
      showUserModal(user, userIndex)
    }
    // const lp = new LightProfileProto()
    // lp.users = randomUsers
    // lp.userId = user.id
    // lp.userIndex = userIndex
    // dispatch(lightProfileActions.openLightProfileModal(lp))
  }
  const navigate = (direction) => {
    let nextUserIndex = direction === 'next' ? currentUserIndex + 1 : currentUserIndex - 1
    if (nextUserIndex > randomUsers.length - 1) {
      nextUserIndex = 0
    } else if (nextUserIndex < 0) {
      nextUserIndex = randomUsers.length - 1
    }
    setCurrentUserIndex(nextUserIndex)
    setCurrentUser(randomUsers[nextUserIndex])
  }

  return (
    <WidgetContainer title={title || t('widgets.getToMeet.title')}>
      <div className={styles.getToMeetContainer}>
        <button
          disabled={currentUserIndex === 0}
          onClick={() => navigate('prev')}
          className={`${styles.btnNav} ${styles.leftNav}`}
          aria-label={t('global.prevNavigation', { type: '' })}>
          <Icon name='chevron-left24' size={'large24'} />
        </button>
        {currentUser && (
          <Avatar
            containerCSS={`${styles.avatar}`}
            imgWrapperSize='large100'
            userId={currentUser.id}
            profilePicture={currentUser.profile_picture}
            firstname={currentUser.firstname}
            lastname={currentUser.lastname}
            showImageAsDecorative={true}
            onClickAction={() => handleShowUserModal(currentUser, currentUserIndex)}
            mimeType={currentUser.mime_type}
            originalTag={currentUser.original_tag}
            isOriginal={currentUser.is_original}
            showUserName={true}
            showCommonInterests={true}
            commonInterestsCount={currentUser.interests_in_common_count}
            withExpertiseGroup={currentUser.with_expertise_group}
          />
        )}

        <button
          disabled={currentUserIndex === randomUsers.length - 1}
          onClick={() => navigate('next')}
          className={`${styles.btnNav} ${styles.rightNav}`}
          aria-label={t('global.nextNavigation', { type: '' })}>
          <Icon name='chevron-right24' size={'large24'} />
        </button>
      </div>
      {showMixrUrl && currentUser?.mixr_url && (
        <LinkButton
          reactLink={false}
          customStyle={styles.attendMixr}
          text={'Attend mixr'}
          href={currentUser.mixr_url}
        />
      )}
      {showProfileUrl && currentUser?.profile_url && (
        <LinkButton
          reactLink={false}
          customStyle={styles.attendMixr}
          text={'See profile'}
          href={currentUser.profile_url}
        />
      )}
    </WidgetContainer>
  )
}

export default GetToMeet
